export default {
  nav: {
    home: 'Home',
    services: 'Services',
    calculator: 'Calculator',
    work: 'Examples',
    faq: 'FAQ',
  },
  hero: {
    tagline: 'Custom Telegram bots',
    label: 'Telegram bot agency',
    title1: 'Telegram bot',
    title2: 'in 7 days',
    title3: 'done right',
    subtitle:
      'Sales, support, booking, broadcasts — automate the work that takes hours a day. Timeline and price are fixed in the contract before we start.',
    cta: 'Choose a bot type',
    stat1: 'From',
    stat1Value: '2 days',
    stat2: 'Support',
    stat2Value: '30 days',
    stat3: 'From',
    stat3Value: 'from 15 000 ₽',
  },
  services: {
    label: 'Catalog',
    title: 'Choose a bot type',
    select: 'Select',
    selected: 'Selected',
    complexity: 'Complexity',
    complexityLow: 'Simple',
    complexityMedium: 'Medium',
    complexityHigh: 'Advanced',
    bots: {
      'ai-support': {
        name: 'AI Support',
        desc: 'Automated answers to common customer questions 24/7. Escalates complex cases to a human.',
        features: ['GPT integration', '24/7 replies', 'Multilingual', 'CRM handoff'],
      },
      ecommerce: {
        name: 'Store',
        desc: 'Catalog, cart, payments and order tracking inside Telegram.',
        features: ['Catalog', 'Cart', 'Payments', 'Order status'],
      },
      subscription: {
        name: 'Subscriptions',
        desc: 'Private channel/chat with tiers, auto-renewal and analytics.',
        features: ['Tiers', 'Auto-renewal', 'Invite links', 'Analytics'],
      },
      'lead-gen': {
        name: 'Lead Generation',
        desc: 'Lead qualification via dialog, scoring and CRM handoff.',
        features: ['Funnel', 'CRM integration', 'Scoring', 'Notifications'],
      },
      trading: {
        name: 'Trading Signals',
        desc: 'Real-time alerts, portfolio tracking, charts.',
        features: ['Signals', 'Portfolio', 'Alerts', 'Charts'],
      },
      booking: {
        name: 'Booking',
        desc: 'Calendar, reminders, payment collection, staff management.',
        features: ['Calendar', 'Reminders', 'Payments', 'Staff'],
      },
      moderation: {
        name: 'Moderation',
        desc: 'Anti-spam, CAPTCHA, welcome messages, rule enforcement, admin tools.',
        features: ['Anti-spam', 'CAPTCHA', 'Welcome', 'Admin tools'],
      },
      education: {
        name: 'Courses',
        desc: 'Lessons, progress, quizzes, certificates, student management.',
        features: ['Lessons', 'Progress', 'Quizzes', 'Certificates'],
      },
    },
  },
  info: {
    label: 'How we work',
    title: 'What you get',
    subtitle:
      'Transparent terms locked in the contract before we start.',
    carouselLabel: 'Agency advantages',
    dotsLabel: 'Select slide',
    prevSlide: 'Previous slide',
    nextSlide: 'Next slide',
    of: 'of',
    badge: {
      included: 'Included',
      highlight: 'Key point',
    },
    slides: {
      contract: {
        title: 'Contract before payment',
        desc: 'We sign terms, lock the price and timeline. Only then do we invoice.',
      },
      prototype: {
        title: 'Working prototype in 2–3 days',
        desc: 'A functional bot with core logic within 48–72 hours of the scope sign-off.',
      },
      deploy: {
        title: 'Production in 1–2 weeks',
        desc: 'From kickoff to live deployment usually takes 7–14 business days. Complex integrations follow a roadmap.',
      },
      ai: {
        title: 'GPT-4o and Claude 3.5 Sonnet',
        desc: 'Your pick of OpenAI GPT-4o / 4o-mini or Anthropic Claude 3.5 Sonnet. System prompts tuned to your niche.',
      },
      crm: {
        title: 'CRM integrations',
        desc: 'AmoCRM, Bitrix24, HubSpot, Google Sheets, webhooks. Leads and orders land where your sales team works.',
      },
      payments: {
        title: 'Payments for any market',
        desc: 'Telegram Stars, SBP, RU cards, Tribute for EU/US cards. USDT/TON on request. Pre-checkout validation built-in.',
      },
      multilang: {
        title: 'Multilingual out of the box',
        desc: 'Auto-detects the user language from Telegram locale. RU, EN and any extra language on request.',
      },
      security: {
        title: 'AES-GCM and audit logs',
        desc: 'Encryption for sensitive data, HMAC-verified webhooks, full audit trail for user and admin actions.',
      },
      hosting: {
        title: '6 months of hosting included',
        desc: 'VPS, domain and SSL on us for the first six months. After that: 1 500 ₽/mo or migrate to your own infra.',
      },
      support: {
        title: '30 days of free revisions',
        desc: 'Tweaks and small changes for a month after handover at no extra cost. After that: monthly plan or self-host.',
      },
      sources: {
        title: 'You own the source code',
        desc: 'After the final payment you get the full codebase, docs and credentials. No vendor lock-in.',
      },
    },
  },
  calculator: {
    label: 'Calculator',
    title: 'Estimate your project',
    botType: 'Bot type',
    complexity: 'Complexity level',
    basic: 'Basic',
    standard: 'Standard',
    advanced: 'Advanced',
    features: 'Additional features',
    featuresList: {
      ai: 'AI integration',
      payments: 'Payment processing',
      dashboard: 'Admin dashboard',
      crm: 'CRM integration',
      multilang: 'Multi-language',
      analytics: 'Analytics',
      api: 'API / Webhooks',
      design: 'Custom design',
    },
    expressDelivery: 'Express delivery (48 h)',
    expressExtra: '+30%',
    priceLabel: 'Estimated price',
    delivery: 'Delivery',
    days: 'business days',
    orderBtn: 'Send request',
    disclaimer:
      'Final price and timeline are fixed in the contract after a short call.',
  },
  portfolio: {
    label: 'Examples',
    title: 'Projects we build',
    projects: {
      crypto: {
        name: 'Trading signals',
        desc: 'Real-time alerts, portfolio tracking and charts.',
        category: 'Crypto',
      },
      shop: {
        name: 'E-commerce store',
        desc: 'Catalog, cart and payments inside Telegram.',
        category: 'E-commerce',
      },
      edu: {
        name: 'Course platform',
        desc: 'Lessons, progress, quizzes, certificates.',
        category: 'Education',
      },
      med: {
        name: 'Clinic booking',
        desc: 'Appointments, reminders, payments.',
        category: 'Healthcare',
      },
      support: {
        name: 'AI support',
        desc: '24/7 automated replies with human escalation.',
        category: 'Support',
      },
      event: {
        name: 'Event management',
        desc: 'Tickets, QR check-in, attendee broadcasts.',
        category: 'Events',
      },
    },
    stats: { time: 'days', users: 'users' },
  },
  process: {
    label: 'Process',
    title: 'How we work',
    steps: {
      1: {
        title: 'Day 0: discuss',
        desc: 'A 15-minute call on Telegram. Same day — quote and a written scope.',
      },
      2: {
        title: 'Day 1–2: prototype',
        desc: 'You see a working prototype. Not happy — you walk away, no further payment.',
      },
      3: {
        title: 'Day 3–7: build',
        desc: 'Final features, testing, deployment on our server.',
      },
      4: {
        title: 'Day 7+: support',
        desc: '30 days of free fixes included. After that — support on subscription.',
      },
    },
  },
  faq: {
    label: 'FAQ',
    title: 'Common questions',
    questions: [
      {
        q: 'How long does development take?',
        a: 'Basic bots take 2–5 business days. Standard projects 5–10 days. Complex AI / integrations 10–21 days. 48-hour express delivery is available for +30%.',
      },
      {
        q: 'What if I don\'t like the result?',
        a: 'You pay 50% after the prototype. If it doesn\'t fit — you don\'t pay the rest, and the prototype sources stay with you.',
      },
      {
        q: 'Who hosts the bot?',
        a: 'First 6 months on our server, free. After that — 1 500 ₽/mo with us, or we hand it over to your infrastructure.',
      },
      {
        q: 'What if the bot breaks after a month?',
        a: '30 days of free fixes after delivery. After that — support from 5 000 ₽/mo, or take the sources and self-host.',
      },
      {
        q: 'I don\'t have a spec. Now what?',
        a: 'We write the spec after a 15-minute call. Free, before any contract is signed.',
      },
      {
        q: 'How can I pay?',
        a: 'Telegram Stars, bank transfer, Russian cards (SBP), international cards via Stripe, USDT/TON. Standard split: 50% after prototype, 50% on delivery.',
      },
      {
        q: 'What if Telegram bans the bot?',
        a: 'We build on the official Bot API and within Telegram\'s rules. If a ban happens not because of your content — we help restore it or build a backup bot.',
      },
      {
        q: 'Do you hand over the source code?',
        a: 'Yes. On final payment — all source code, docs and credentials. Stack: Node.js + MySQL, bot on Telegraf.',
      },
    ],
  },
  order: {
    title: 'Send a request',
    description: 'Project description',
    descPlaceholder:
      'What should the bot do? Who is the audience? Any references?',
    budget: 'Approximate budget',
    budgets: ['Up to 25 000 ₽', '25 000 – 50 000 ₽', '50 000 – 100 000 ₽', '100 000 ₽+', 'Not sure'],
    submit: 'Send',
    creating: 'Sending…',
    success: 'Request received',
    successMsg:
      'A manager will reach out in Telegram within 24 hours. You can also chat with the bot directly.',
    successCta: 'Got it',
    error: 'Could not send. Please try again later.',
    paymentTitle: 'Payment method',
    paymentNote: 'Picking a payment method is optional at this stage.',
    paymentStars: 'Telegram Stars',
    paymentRuCard: 'Russian Card',
    paymentIntlCard: 'International Card',
    paymentCrypto: 'Crypto (USDT/TON)',
    paymentMethodNote:
      'A manager will send the final invoice after we agree on the scope.',
    payNow: 'Pay',
    back: 'Back',
    notInTelegram:
      'Open the app from Telegram to submit a request. Sending is disabled in a regular browser.',
    serviceLabel: 'Bot type',
  },
  lang: { ru: 'RU', en: 'EN' },
  common: {
    openInTelegram: 'Open in Telegram',
    openBotInTelegram: 'Open the bot in Telegram',
    inBrowserHint:
      "You're viewing this in a browser. Open the bot in Telegram to access payments, order flow and automatic identification.",
    account: 'Account',
    signIn: 'Sign in',
  },
  auth: {
    backToHome: 'Back to home',
    signIn: 'Sign in with Telegram',
    signInHint:
      'Sign in with Telegram — we use the standard Telegram Login Widget. No passwords: confirm on your phone and you are in.',
    signInPrivacy:
      'By signing in you agree to the privacy policy. We only receive your public Telegram profile (name, username, photo).',
    logout: 'Sign out',
    loading: 'Loading…',
  },
  account: {
    loading: 'Loading…',
    goToCatalog: 'Open the catalog',
    tabs: {
      profile: 'Profile',
      orders: 'Orders',
      payments: 'Payments',
      messages: 'Messages',
    },
    summary: {
      orders: 'Total orders',
      active: 'In progress',
      completed: 'Completed',
      paid: 'Paid',
    },
    profile: {
      telegramData: 'Telegram identity',
      accountInfo: 'Account information',
      firstName: 'First name',
      lastName: 'Last name',
      username: 'Username',
      telegramId: 'Telegram ID',
      registered: 'Registered',
      lastLogin: 'Last login',
      title: 'Contact details',
      subtitle: 'These fields are visible to the manager handling your order.',
      email: 'Email',
      phone: 'Phone',
      notes: 'Notes for the manager',
      notesPlaceholder:
        'Anything that helps us reach you: preferred channel, time of day, links to references.',
      save: 'Save',
      saving: 'Saving…',
      saved: 'Saved',
    },
    orders: {
      empty: 'No orders yet. Use the calculator on the home page to start one.',
      orderNo: 'Order #{{id}}',
      paymentPending: 'payment pending',
      price: 'Price',
      budget: 'Budget',
      paymentMethod: 'Payment method',
      payments: 'Payment',
      viewPayments: 'View payments',
    },
    payments: {
      empty: 'No payments yet.',
      orderRef: 'For order #{{id}}',
      txn: 'Transaction id',
      viewOrder: 'Open order',
    },
    messages: {
      empty: 'Your chat history with the bot will appear here.',
    },
  },
} as const;
